const sendText = async (axios, request) => {
  request.phoneNumber = request.phoneNumber.indexOf("+") === 0 ? request.phoneNumber : `+1${request.phoneNumber}`;
  const res = await axios.post("/waitingList/textLinkToDownloadApp", request);
  return res == null ? void 0 : res.data;
};
const searchProductsRest = async (axios, body, page, facets, cancelToken) => {
  const res = await axios.post(
    "/product/search",
    { body, page, facets },
    {
      cancelToken
    }
  );
  return res == null ? void 0 : res.data;
};
const getEntityForLandingPage = async ({
  axiosEdgeCached,
  entityId,
  entityType
}) => {
  return axiosEdgeCached.get(`/cms/landing/${entityType}/${entityId}/entity`);
};
const getRecentlySearchedTerms = async (axios, headers) => {
  return axios.get("/recentlyViewed/getSearches", { headers });
};
export {
  getEntityForLandingPage,
  getRecentlySearchedTerms,
  searchProductsRest,
  sendText
};
//# sourceMappingURL=utils.js.map
